// In development, I have a keyboard shortcut that allows me to view the hidden text. In production, it's a much simpler component.
// Decided to split it up this way to avoid polluting the client bundle with development-only code. This way, the production component is a Server Component.
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./VisuallyHidden');
} else {
  module.exports = require('./VisuallyHidden.dev');
}
